export default [
  {
    path: '/adminsystem/dept',//部门管理
    name: 'dept',
    component: () => import('@/views/adminsystem/dept')
  },
  {
    path: '/adminsystem/oper',//用户管理
    name: 'oper',
    component: () => import('@/views/adminsystem/oper')
  },
  {
    path: '/adminsystem/myrole',//角色管理
    name: 'myrole',
    component: () => import('@/views/adminsystem/myrole')
  },
  {
    path: '/adminsystem/homeMenu',//首页入口
    name: 'homeMenu',
    component: () => import('@/views/adminsystem/homeMenu')
  },
  {
    path: '/adminsystem/menuitem',//菜单
    name: 'menuitem',
    component: () => import('@/views/adminsystem/menuitem')
  },
  {
    path: '/adminsystem/organization',//机构管理
    name: 'organization',
    component: () => import('@/views/adminsystem/organization')
  },
  {
    path: '/adminsystem/myrole_setNode',//设备权限
    name: 'myrole_setNode',
    component: () => import('@/views/adminsystem/myrole_setNode')
  },
  {
    path: '/adminsystem/homeMenu1',//测试按钮
    name: 'homeMenu1',
    component: () => import('@/views/adminsystem/homeMenu1')
  },
  {
    path: '/adminsystem/operationLog',//操作日志
    name: 'operationLog',
    component: () => import('@/views/adminsystem/operationLog')
  },
  {
	path: '/adminsystem/subsystem',//子系统管理
	name: 'subsystem',
	component: () => import('@/views/adminsystem/subsystem')
  },
]



// WEBPACK FOOTER //
// ./src/router/system.js